import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface mapState {
	isLoading: boolean;
	LocatoinList: any;
	// totalHoliday: number;
	// holidayDetail: any;
}

const initialState: mapState = {
	isLoading: false,
	LocatoinList: []
	// totalHoliday: 0,
	// holidayDetail: {}
};

const mapSlice = createSlice({
	name: 'mapSlice',
	initialState,
	reducers: {
		getAllLocationInit: state => {
			state.isLoading = true;
			state.LocatoinList = [];
		},
		getAllLocationSuccess: (state, action: PayloadAction<any>) => {
			state.isLoading = false;
			const data = action.payload.data;
			state.LocatoinList = [...data.driversDetails];
		},
		getAllLocationError: state => {
			state.isLoading = true;
			state.LocatoinList = [];
		}
	}
});

export const { getAllLocationError, getAllLocationInit, getAllLocationSuccess } =
	mapSlice.actions;

export default mapSlice.reducer;
